<div class="appctrl-row">
  <button
    [disabled]="showLoadingIndicator || vispApp.disabled"
    class="tool-tile app-tone"
    [class.disabled-btn]="vispApp.disabled"
    [class.running]="hasRunningSessions"
    (click)="vispApp.name === 'tratt' ? selectAppOptions() : launchProjectInApp()">

    <span class="tile-icon accent" [ngSwitch]="vispApp.name">
      <i class="fa fa-commenting-o" *ngSwitchCase="'tratt'" aria-hidden="true"></i>
      <i class="fa fa-pencil" *ngSwitchCase="'artic'" aria-hidden="true"></i>
      <i class="fa fa-code" *ngSwitchCase="'jupyter'" aria-hidden="true"></i>
      <img *ngSwitchDefault [src]="appIconPath" [alt]="vispApp.title + ' icon'">
    </span>

    <span class="tile-copy">
      <span class="tile-label">{{ btnTitle }}</span>
      <span *ngIf="vispApp.subtitle && !(vispApp.name === 'jupyter' && statusMsg.length > 0)" class="tile-subtitle">{{ vispApp.subtitle }}</span>
      <span *ngIf="statusMsg.length > 0" class="tile-status">
        <img *ngIf="showLoadingIndicator" src="../../../assets/loading-indicator-4-light.svg" alt="Loading">
        {{ statusMsg }}
      </span>
    </span>

    <i class="fa fa-chevron-right tile-chevron" aria-hidden="true"></i>
  </button>

  <button class="session-close-button" *ngIf="hasRunningSessions" [disabled]="showLoadingIndicator" (click)="close()" aria-label="Close running session">
    <i class="fa fa-times-circle" aria-hidden="true"></i>
  </button>
</div>
